import React, {useCallback}                                                     from 'react';
import {useMobile}                                                              from "../../../../hooks/system/useMobile";
import {Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";

export interface DialogState {
  isOpen    : boolean
  messages  : string[]
  title     : string
}

export interface OrderDialogProps {
  orderDialogState  : DialogState
  onClose           : () => void
}

export const OrderDialog = (p: OrderDialogProps) => {
  const isMobile    = useMobile('sm');

  const onClose     = useCallback(() => {
    p.onClose();
  }, [p])

  return (
    <Dialog open={p.orderDialogState.isOpen} maxWidth='sm' fullWidth fullScreen={isMobile}>
      <DialogTitle>{p.orderDialogState.title ? p.orderDialogState.title : "Order Rejected"}</DialogTitle>
      <DialogContent>
        {p.orderDialogState.messages && p.orderDialogState.messages.map((message: string) => {
          return <p>{message}</p>
        })}
      </DialogContent>
      <DialogActions>
        <ButtonGroup variant='outlined'>
          <Button onClick={onClose}>Close</Button>
        </ButtonGroup>
      </DialogActions>
    </Dialog>
  )
}
